<template>
<!-- Start Projects Area
    ============================================= -->
    <div
      id="tutoriales"
      class="projects-area overflow-hidden carousel-shadow default-padding"
    >
      <!-- Fixed BG -->
      <div
        class="fixed-bg"
        style="background-image: url(assets/img/shape/2.png)"
      ></div>
      <!-- Fixed BG -->
      <div class="container">
        <div class="heading-left">
          <div class="row">
            <div class="col-lg-5" id="videos">
              <h2>Videos y tutoriales de conexión con distintos brokers</h2>
            </div>
            <!--<div class="col-lg-6 offset-lg-1">
                        <p>
                            Everything melancholy uncommonly but solicitude inhabiting projection off. Connection stimulated estimating excellence an to impression. 
                        </p>
                        <a class="btn circle btn-md btn-gradient wow fadeInUp" href="#">View All <i class="fas fa-plus"></i></a>
                    </div>-->
          </div>
        </div>
        <div
          class="projects-items col-lg-12 wow fadeInUp"
          data-wow-delay="0.2s"
        >
          <div class="row">
            <div class="projects-carousel owl-carousel owl-theme">
              <!-- Single Item -->
              <div class="single-item">
                <iframe
                  width="100%"
                  height="280"
                  :src="cons.links.tutoriales.ingresoEscritorio"
                  frameborder="1"
                  allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"
                  allowfullscreen
                ></iframe>
                <div class="info">
                  <ul>
                    <li>¿Cómo ingreso por Escritorio?</li>
                  </ul>
                </div>
              </div>
              <!-- End Single Item -->
              <!-- Single Item -->
              <div class="single-item">
                <iframe
                  width="100%"
                  height="280"
                  :src="cons.links.tutoriales.ingresoWeb"
                  frameborder="1"
                  allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"
                  allowfullscreen
                ></iframe>
                <div class="info">
                  <ul>
                    <li>¿Cómo ingreso por Web?</li>
                  </ul>
                </div>
              </div>
              <!-- End Single Item -->
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- End Projects Area -->
</template>


<script>
    import cons from '@/utils/const';
    export default {
        name: "Banner4",
        components: {},
        data() {
            return { cons };
        },
        beforeMount() {},
    };
</script>